<script>
  import { currentLang } from "stores.js";

  export let videos;
</script>

{#if videos}
  <div class="videos-wrapper">
    {#each videos as video}
      <div>
        <iframe
          src={video.url[$currentLang]}
          frameborder="0"
          allow="accelerometer; autoplay; fullscreen; gyroscope; picture-in-picture"
          allowfullscreen
          title={video.title[$currentLang]}
        />
        {#if video.title}
          <h2 class="video-title">{video.title[$currentLang] || ""}</h2>
        {/if}
      </div>
    {/each}
  </div>
{/if}

<style>
  .videos-wrapper {
    margin: 24px 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, 250px);
    grid-gap: 48px;
  }

  .video-title {
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    margin-top: 12px;
    padding: 0 16px;
  }
</style>
